import TripStatistics from "../../../views/TripStatistics";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const tripStatisticsRoutes = [
  {
    menuName: MenuNames.TRIP_STATISTICS,
    path: "/trip-statistics",
    component: TripStatistics,
    exact: true,
  },
];

export default tripStatisticsRoutes;
